import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileService } from '../../../../shared/services/file.service';

export interface RejectDocumentDialogData {
  fileId: string;
  fileName: string;
  professionalName: string;
}

@Component({
  selector: 'app-reject-document-modal',
  templateUrl: './reject-document-modal.component.html',
  styleUrls: ['./reject-document-modal.component.scss']
})
export class RejectDocumentModalComponent {
  rejectForm: FormGroup;
  isSubmitting = false;

  constructor(
    public dialogRef: MatDialogRef<RejectDocumentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RejectDocumentDialogData,
    private formBuilder: FormBuilder,
    private fileService: FileService,
    private snackbar: MatSnackBar
  ) {
    this.rejectForm = this.formBuilder.group({
      reason: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]]
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    if (this.rejectForm.invalid || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    const reason = this.rejectForm.get('reason')?.value;

    this.fileService.check('REJECTED', this.data.fileId, reason).subscribe(
      () => {
        this.snackbar.open('Documento rejeitado e notificação enviada via WhatsApp', 'OK', { 
          duration: 5000 
        });
        this.dialogRef.close(true);
      },
      (error) => {
        this.snackbar.open(
          'Não foi possível rejeitar o documento. Tente novamente mais tarde!',
          'OK',
          { duration: 3000 }
        );
        this.isSubmitting = false;
      }
    );
  }

  hasError(controlName: string, errorName: string): boolean {
    return this.rejectForm.controls[controlName].hasError(errorName);
  }
}
